import {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
  MouseEvent,
  useMemo,
} from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";
import multiMonthPlugin from "@fullcalendar/multimonth";
import listPlugin from "@fullcalendar/list";
import {
  DateSelectArg,
  DateSpanApi,
  EventClickArg,
  EventDropArg,
} from "@fullcalendar/core/index.js";
import BookingForm from "./BookingForm";
import usePopup from "../../../hooks/usePopup";
import { PatientBookingContext } from "./context/PatientBookingProvider";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  LinearProgress,
  ListItemText,
  Menu,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import {
  BookingFormType,
  BookingListType,
  prepareConfirmBookingParams,
  prepareUpcomingReviewBookingParams,
  SearchParamsDoctorType,
  UpcomingReviewBookingType,
} from "./types";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useMutation, useQuery } from "react-query";
import {
  BackendDoctor,
  BackendDoctorBooking,
  cancelBookingPermanent,
  getAllDoctorsBooking,
  getBookingWithReviewDate,
  updateBookings,
} from "./services";
import momentPlugin from "@fullcalendar/moment";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import moduleRoutes from "../../../routes/moduleRouteList";
import patientCareRouteList from "../../routeList";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import { calculateAge } from "../../../utilis/methods/dateMethods";
import {
  formatLocalDateTime,
} from "../../../utilis/methods/localDateTime";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { clinicId } from "../../../constants";
import reportsRoutesList from "../../../Reports/routesList";
import useBookingSave from "./apiHooks";
import { getCountry } from "../../Patientregistration/v2/registrationServices";
import { getCountryCodeForBooking } from "./countryCodeUtils";
import useAuthentication from "@hooks/useAuthentication";
import { CustomFormField } from "@utilifiles/component/CustomFormElement";
import { useForm } from "react-hook-form";
import DoctorSelectDropdown from "./DoctorSelectDropdown";
type CopyType = "single" | "multi" | null;
const base = (window as any)._env_?.BASE_URL;
let updateFn = () => { };
function CalenderComponent() {
  const theme = useTheme();
  const navigate = useNavigate();
  const calendarRef = useRef(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const skipDetailsCloseRef = useRef(false);
  const selectedBookingIdRef = useRef<string | number | null>(null);
  const { showSnackbar, CustomModal } = usePopup();

  useEffect(() => {
    if (!wrapperRef.current) return;

    // Using setTimeout inside ResizeObserver to ensure that
    // updateSize handles the gradual sidebar CSS transition effectively without leaving whitespace pixel gaps.
    let timeoutId: any;
    const resizeObserver = new ResizeObserver(() => {
      if (calendarRef.current) {
        try {
          (calendarRef.current as any).getApi().updateSize();
        } catch (e) { }
      }
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        if (calendarRef.current) {
          try {
            (calendarRef.current as any).getApi().updateSize();
          } catch (e) { }
        }
      }, 250);
    });

    resizeObserver.observe(wrapperRef.current);

    return () => {
      resizeObserver.disconnect();
      clearTimeout(timeoutId);
    };
  }, []);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [copy, setCopy] = useState<CopyType>(null);
  const { control, setValue } = useForm();
  const [copyOpen, setCopyOpen] = useState<boolean>(false);
  const [confirm, setConfirm] = useState(false);
  const {
    bookingList,
    setBookingList,
    setTimeSlot,
    open,
    setOpen,
    refetch,
    setRefetch,
    editDetails,
    setEditDetails,
    setBookingSearchParams,
    bookingSearchParam,
    setCopyId,
  } = useContext(PatientBookingContext);

  const { user } = useAuthentication();
  const countrycodegrants = user?.region === "QATAR_REGION";

  const { data: countries } = useQuery(["getCountryBooking"], getCountry, {
    refetchOnWindowFocus: false,
  });

  const resolveBookingCountryCode = (source: Partial<BookingFormType>) =>
    getCountryCodeForBooking(
      source,
      countries?.response,
      countrycodegrants,
    );

  useEffect(() => {
    if (!editDetails?.id || !countries?.response?.length) return;
    setEditDetails((prev) => {
      if (!prev) return prev;
      const countryCode = getCountryCodeForBooking(
        prev,
        countries?.response,
        countrycodegrants,
      );
      const currentId = prev.countryCodeId ?? prev.countryCode?.id;
      if (currentId == countryCode.id) return prev;
      return {
        ...prev,
        countryCode,
        countryCodeId: prev.countryCodeId ?? countryCode.id,
      };
    });
  }, [editDetails?.id, editDetails?.countryCodeId, countries?.response]);

  const { mutate: fetchAllDoctors, isLoading: doctorsLoading } = useMutation(
    getAllDoctorsBooking,
    {
      onSuccess: (result) => {
        if (result.responseIndicator === "success") {
          const { doctors, doctorBookings } = result.response;
          setBookingDoctors(doctors ?? []);
          const resources = mapDoctorsToResources(doctors, doctorBookings);
          console.log("doctorBookings", doctorBookings);
          const events = mapDoctorBookingsToEvents(doctorBookings).filter(
            (event: any) => event.extendedProps.data.status !== 2,
          );
          console.log("events", events);
          setAllResources(resources);
          setAllEvents(events);
          setFilteredEvents(events);
          setBookingList(events);
          setRefetch(false);
          if (selectedBookingIdRef.current) {
            skipDetailsCloseRef.current = true;
          }
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 3000,
          });
        }
      },
    },
  );

  const mapDoctorsToResources = (
    doctors: BackendDoctor[],
    doctorBookings: BackendDoctorBooking[],
  ) => {
    const bookingMap = new Map<number, BackendDoctorBooking>();
    doctorBookings.forEach((d) => {
      bookingMap.set(d.doctorId, d);
    });
    return doctors.map((doc) => {
      const bookingDoctor = bookingMap.get(doc.doctorId);
      return {
        id: String(doc.doctorId),
        title: doc.doctorName,
        color: doc.color,

        extendedProps: {
          durationForPatient: doc.durationForPatient,
          visitType: doc.visitType,
          department: bookingDoctor?.department
            ? {
              departmentId: bookingDoctor.department.departmentId,
              departmentName: bookingDoctor.department.departmentName,
            }
            : doc.departmentId
              ? {
                departmentId: doc.departmentId,
                departmentName: doc.departmentName,
              }
              : null,
        },
      };
    });
  };

  const mapDoctorBookingsToEvents = (doctorBookings: any[]) => {
    return doctorBookings.flatMap((doctor) =>
      doctor.bookings.map((booking: any) => {
        console.log("booking", booking);
        return {
          id: String(booking.id),
          title: booking.patientName,
          start: booking.start,
          end: booking.end,
          resourceId: String(doctor.doctorId),
          extendedProps: {
            data: {
              id: booking.id,
              firstName: booking.firstName,
              middleName: booking.middleName,
              lastName: booking.lastName,
              mobileNumber: booking.mobile,
              tokenNo: booking.tokenNo,
              status: booking.status,
              timeSlot: booking.timeSlotNo,
              dob: booking.dob,
              gender: booking.gender,
              isCompleted: booking.isCompleted,
              patientId: booking.patientId,
              ageYears: booking.ageYears,
              ageMonths: booking.ageMonths,
              ageDays: booking.ageDays,
              visitType: booking.visitType,
              roomNo: booking.roomNo,
              email: booking.email,
              notes: booking.notes,
              doctor: {
                doctorId: doctor.doctorId,
                doctorName: doctor.doctorName,
                color: doctor.color,
              },
              department: {
                departmentId: doctor.department?.departmentId,
                departmentName: doctor.department?.departmentName,
              },
              temporaryBooking: booking.temporaryBooking,
              bookingConfirmed: booking.bookingConfirmed,
              reason: booking.reason,
              startDate: booking.start,
              endDate: booking.end,
              journeyStatus: booking.journeyStatus,
              countryCodeId: booking.countryCodeId,
              grouping: booking.grouping ?? null,
            },
          },
        };
      })
    );
  };

  const getDisplayStatus = (status: string) => {
  if (status === "Emr Started") return "In Care";
  return status;
};
// const isInCare = data?.journeyStatus === "Emr Started";
  const { mutate: bookingUpdate } = useMutation(updateBookings, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        setRefetch(true);
        setConfirm(false);
      } else {
        showSnackbar({
          message: result?.responseMessage || "Error !",
          open: true,
          variant: "warning",
          duration: 2000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message: e?.response?.data?.responseMessage || "Something went wrong !",
        open: true,
        variant: "warning",
        duration: 2000,
      });
      setRefetch(true);
    },
  });

  const { mutate: bookingCancelPermanent, isLoading: cancelLoading } =
    useMutation(cancelBookingPermanent, {
      onSuccess: (result) => {
        setRefetch(true);
        if (result.responseIndicator == "fail") {
        } else {
          const updated = bookingList.filter(
            (item) => item.id != editDetails?.id,
          );
          setBookingList(updated);
          showSnackbar({
            message: "Booking cancelled successfully !",
            variant: "success",
            open: true,
            duration: 2000,
          });
          handleCloseDetails();
        }
      },
      onError: (e: any) => {
        setRefetch(true);

        showSnackbar({
          message:
            e?.response?.data?.responseMessage || "Something went wrong !",
          variant: "warning",
          open: true,
          duration: 2000,
        });
      },
    });
  const handleDayCellDidMount = () => {
    const popovers = document.querySelectorAll(".fc-more-popover");
    popovers.forEach((popover) => {
      (popover as HTMLElement).style.maxHeight = "140px";
      (popover as HTMLElement).style.width = "fit-content";
      (popover as HTMLElement).style.overflowY = "auto";
      (popover as HTMLElement).style.zIndex = "999";
    });
  };

  const reanchorBookingDetails = useCallback(() => {
    const bookingId = selectedBookingIdRef.current;
    if (!bookingId || !calendarRef.current) return;
    try {
      const api = (calendarRef.current as { getApi: () => { getEventById: (id: string) => { el?: HTMLElement | null } | null } }).getApi();
      const event = api.getEventById(String(bookingId));
      if (event?.el) {
        setAnchorEl(event.el);
      }
    } catch {
      // Calendar not ready yet.
    }
  }, []);

  const handleCloseDetails = () => {
    selectedBookingIdRef.current = null;
    skipDetailsCloseRef.current = false;
    setAnchorEl(null);
    setEditDetails(null);
  };

  const handleDetailsMenuClose = () => {
    if (skipDetailsCloseRef.current) return;
    handleCloseDetails();
  };

  const hideDetailsPopover = () => {
    selectedBookingIdRef.current = null;
    skipDetailsCloseRef.current = false;
    setAnchorEl(null);
  };

  const checkAvailability = (
    doctor: SearchParamsDoctorType,
    start: string,
    end: string,
  ) => {
    let notification: { message: string; variant: any } | null = null;
    const { timeslots, doctorName } = doctor;
    const startTime = moment.utc(start);
    const endTime = moment.utc(end);
    const startTimeObj = timeslots.find(
      (day: any) => day.dayId == startTime.day(),
    ) as any;
    const endTimeObj = timeslots.find(
      (day: any) => day.dayId == endTime.day(),
    ) as any;

    if (!Boolean(startTimeObj) || !Boolean(endTimeObj)) {
      notification = {
        message: `Dr. ${doctorName} is not available for this time !`,
        variant: "warning",
      };
      return notification;
    }
    const startDate = moment.utc(
      `${moment.utc(start).format("YYYY-MM-DD")}T${startTimeObj.startTime}Z`,
    );
    const endDate = moment.utc(
      `${moment.utc(start).format("YYYY-MM-DD")}T${endTimeObj.endTime}Z`,
    );
    const startValidation = startTime.isBefore(startDate);
    const endValidation = endTime.isAfter(endDate);
    if (startValidation || endValidation) {
      startValidation &&
        endValidation &&
        (notification = {
          message: `Dr. ${doctorName} is available from ${startDate.format("DD-MM-YYYY hh:mm A")} to ${endDate.format("DD-MM-YYYY hh:mm A")}.`,
          variant: "info",
        });
      endValidation &&
        (notification = {
          message: `Dr ${doctorName} is not available from ${endDate.format("DD-MM-YYYY hh:mm A")}`,
          variant: "info",
        });
      startValidation &&
        (notification = {
          message: `Dr. ${doctorName} is available from ${startDate.format("DD-MM-YYYY hh:mm A")}.`,
          variant: "info",
        });
    }
    return notification;
  };

  const handleDateSelect = useCallback(
    (selectInfo: DateSelectArg) => {
      setEditDetails(null);
      const resource = selectInfo.resource;

      if (!resource) {
        setOpen(true);
        return;
      }
      const doctorDuration =
        Number(resource.extendedProps?.durationForPatient) || 15;
      const doctorSlotMinutes = 60 / doctorDuration;
      const start = moment.utc(selectInfo.startStr);
      const selectedMinutes = moment(selectInfo.end).diff(
        moment(selectInfo.start),
        "minutes",
      );
      const isSingleClick = selectedMinutes <= 5;
      const end = isSingleClick
        ? start.clone().add(doctorSlotMinutes, "minutes")
        : moment.utc(selectInfo.endStr);
      if (!resource) {
        console.warn("No resource attached to selection");
        return;
      }
      let isBefore =
        selectInfo.view.type == "resourceTimelineMonth" ||
          selectInfo.view.type == "multiMonthYear"
          ? false
          : moment(selectInfo.startStr).isBefore(
            moment().format("YYYY-MM-DDTHH:mm:ss[Z]"),
            "minutes",
          );
      if (bookingSearchParam.doctor) {
        const { timeslots, doctorName } =
          bookingSearchParam.doctor as SearchParamsDoctorType;
        const startTime = moment.utc(selectInfo.startStr);
        const startTimeObj = timeslots.find(
          (day: any) => day.dayId == startTime.day(),
        ) as any;
        if (!Boolean(startTimeObj)) {
          showSnackbar({
            message: `Dr. ${doctorName} is not available for this date !`,
            variant: "info",
            open: true,
            duration: 4000,
            origin: { vertical: "bottom", horizontal: "left" },
            direction: "right",
          });
          return;
        }
      }
      if (
        bookingSearchParam.doctor &&
        selectInfo.view.type != "dayGridMonth" &&
        selectInfo.view.type != "multiMonthYear"
      ) {
        const dateWarning = checkAvailability(
          bookingSearchParam.doctor,
          selectInfo.startStr,
          selectInfo.endStr,
        );
        if (dateWarning) {
          showSnackbar({
            ...dateWarning,
            open: true,
            duration: 4000,
            origin: { vertical: "bottom", horizontal: "left" },
            direction: "right",
          });
          return;
        }
      }
      if (isBefore) {
        showSnackbar({
          message: "Appointment Date should be greater than current time",
          open: true,
          variant: "warning",
          duration: 4000,
          origin: { vertical: "bottom", horizontal: "left" },
          direction: "right",
        });
      } else {
        const isMonthView =
          selectInfo.view.type === "resourceTimelineMonth" ||
          selectInfo.view.type === "multiMonthYear";
        setTimeSlot({
          slotType: selectInfo.view.type,

          startTime: selectInfo.startStr,
          endTime: isMonthView ? null : end.toISOString(),
          timeSlotNo: 0,
          times: "",
          doctor: {
            doctorId: Number(resource.id),
            doctorName: resource.title,
            color: resource.extendedProps?.color,
          },
          department: {
            departmentId: resource.extendedProps?.department?.departmentId,
            departmentName: resource.extendedProps?.department?.departmentName,
          },
          visitType: resource.extendedProps?.department?.departmentId,
          notes: resource.extendedProps?.department?.notes,
          email: resource.extendedProps?.department?.email,
        });
        if (moment(selectInfo.startStr).isBefore(moment(), "day")) {
          showSnackbar({
            message: "Appointment Date should be greater than current time",
            open: true,
            variant: "warning",
            duration: 4000,
            origin: { vertical: "bottom", horizontal: "left" },
            direction: "right",
          });
          return;
        } else {
          setOpen(true);
        }
      }
    },
    [copy],
  );
  const handleEventClick = (selectedEvent: EventClickArg) => {
    const data = selectedEvent.event.extendedProps.data;
    if (!data?.startDate || !data?.endDate) {
      return;
    }
    if (Boolean(editDetails)) {
      selectedBookingIdRef.current = null;
      setEditDetails(null);
      setAnchorEl(null);
    } else {
      const data = selectedEvent.event.extendedProps.data;
      const countryCode = resolveBookingCountryCode(data);

      const visitTypeObj = {
        id: Number(data.visitType),
      };
      setTimeSlot({
        slotType: "",
        startTime: null,
        endTime: null,
        timeSlotNo: 0,
        times: "",
        visitType: "",
        notes: "",
        email: "",
      });
      setEditDetails({
        ...data,
        start: selectedEvent.event.start,
        end: selectedEvent.event.end,
        timeSlot: data.timeSlot,
        isCompleted: data.isCompleted,
        visitType: visitTypeObj,
        roomNo: data.roomNo,
        notes: data.notes,
        email: data.email,
        countryCode,
        countryCodeId: data.countryCodeId ?? countryCode.id,
      } as BookingFormType);
      setAnchorEl(selectedEvent.el);
    }
  };

  const handleEventDrop = (selectedEvent: EventDropArg) => {
    updateFn = () => {
      bookingUpdate({
        bookingId: parseInt(selectedEvent.event.id),
        doctorId: selectedEvent.event.extendedProps.data.doctor.doctorId,
        startBookingDate: selectedEvent.event.startStr,
        endBookingDate: selectedEvent.event.endStr,
      });
    };
    // updateFn();
    setConfirm(true);
  };

  const handleEventResize = (selectedEvent: any) => {
    bookingUpdate({
      bookingId: parseInt(selectedEvent.event.id),
      doctorId: selectedEvent.event.extendedProps.data.doctor.doctorId,
      startBookingDate: selectedEvent.event.startStr,
      endBookingDate: selectedEvent.event.endStr,
    });
  };

  const handleDrag = (dropInfo: DateSpanApi) => {
    const isValid = moment(dropInfo.startStr).isBefore();
    return !isValid;
  };

  const handleEdit = () => {
    setAnchorEl(null);
    if (editDetails) {
      const countryCode = resolveBookingCountryCode(editDetails);
      setEditDetails({
        ...editDetails,
        countryCode,
        countryCodeId: editDetails.countryCodeId ?? countryCode.id,
      });
    }
    setOpen(true);
  };

  const handleCloseCopy = () => {
    setCopyOpen(false);
  };

  const handleStartCopy = (e: MouseEvent<HTMLButtonElement>) => {
    const copyType = e.currentTarget.getAttribute("data-operation") as CopyType;
    console.log(copyType);
    setCopy(copyType);
    setCopyOpen(false);
    setCopyId({
      departmentId: editDetails?.department?.departmentId as number,
      doctorId: editDetails?.doctor?.doctorId as number,
    });
  };

  const { mutate: saveBooking, isLoading: saveBookingLoading } = useBookingSave();
  const [statusConfirmOpen, setStatusConfirmOpen] = useState(false);
  const [pendingStatus, setPendingStatus] = useState<string | null>(null);
  const [upcomingModalOpen, setUpcomingModalOpen] = useState(false);
  const [upcomingConfirmOpen, setUpcomingConfirmOpen] = useState(false);
  const [selectedUpcoming, setSelectedUpcoming] =
    useState<UpcomingReviewBookingType | null>(null);

  const {
    data: upcomingBookingsData,
    isLoading: upcomingLoading,
    refetch: refetchUpcomingBookings,
  } = useQuery(["getBookingWithReviewDate"], getBookingWithReviewDate, {
    enabled: upcomingModalOpen,
    refetchOnWindowFocus: false,
  });

  const upcomingBookings = upcomingBookingsData?.response ?? [];

  const handleOpenUpcomingModal = () => {
    setUpcomingModalOpen(true);
  };

  const handleCloseUpcomingModal = () => {
    setUpcomingModalOpen(false);
    setSelectedUpcoming(null);
    setUpcomingConfirmOpen(false);
  };

  const handleUpcomingItemClick = (item: UpcomingReviewBookingType) => {
    if (item.reviewStatus !== "NOT_CONFIRMED") return;
    setSelectedUpcoming(item);
    setUpcomingConfirmOpen(true);
  };

  const handleCloseUpcomingConfirm = () => {
    setUpcomingConfirmOpen(false);
    setSelectedUpcoming(null);
  };

  const handleConfirmUpcomingBooking = () => {
    if (!selectedUpcoming) return;

    const doctor = bookingDoctors.find(
      (item) => item.doctorId === selectedUpcoming.doctorDetails.doctorId,
    );

    const countryCode = resolveBookingCountryCode({});
    const params = {
      ...prepareUpcomingReviewBookingParams({
        item: selectedUpcoming,
        durationForPatient: doctor?.durationForPatient || 15,
        countryCode,
      }),
      encounterId: selectedUpcoming.patientDetails.encounterId,
    };

    saveBooking(params, {
      onSuccess: (result) => {
        if (result.responseIndicator === "success") {
          setUpcomingConfirmOpen(false);
          setSelectedUpcoming(null);
          refetchUpcomingBookings();
        }
      },
    });
  };

  const handleConfirmStatusUpdate = () => {
    if (!editDetails || !pendingStatus) return;
    const params = prepareConfirmBookingParams(editDetails, pendingStatus);
    saveBooking(params);
    setValue("statusDropdown", pendingStatus);
    setStatusConfirmOpen(false);
    setPendingStatus(null);
    hideDetailsPopover();
  };

  const handleCloseStatusConfirm = () => {
    setStatusConfirmOpen(false);
    setPendingStatus(null);
    setValue("statusDropdown", currentStatus);
  };

  const handleConfirmBooking = (e: any) => {
    console.log("event", e);
    if (!e.target.value || !editDetails) return;
    const selectedStatus = e.target.value;

    if (selectedStatus === editDetails.journeyStatus || selectedStatus === currentStatus) return;
    if (selectedStatus === "Booking Cancelled") {
      setValue("statusDropdown", currentStatus);
      setCancelReason("");
      setCancelModalOpen(true);
      return;
    }

    if (selectedStatus === "Cashed") {
      setPendingStatus(selectedStatus);
      setStatusConfirmOpen(true);
      setValue("statusDropdown", currentStatus);
    } else {
      const params = prepareConfirmBookingParams(editDetails, selectedStatus);
      saveBooking(params);
      setValue("statusDropdown", selectedStatus);
      hideDetailsPopover();
    }
  };

  const handleClose = () => {
    setOpen(false);
    hideDetailsPopover();
    setEditDetails(null);
    setTimeSlot((prev) => ({
      ...prev,
      endTime: null,
      startTime: null,
      slotType: "",
    }));
  };

  const handleDelete = () => {
    if (!editDetails) return;

    // FIRST CLICK → open reason modal
    if (editDetails.status === 1) {
      setCancelReason("");
      setCancelModalOpen(true);
      return;
    }
    bookingCancelPermanent({
      bookingId: Number(editDetails.id),
      permanentDelete: editDetails.status === 1 ? 0 : 1,
      clinicId: clinicId,
      reason: null,
    });
  };
  const [currentView, setCurrentView] = useState("");

  const handleDateChange = (info: any) => {
    setCurrentView(info.view.type);
    const isWeekView = info.view.type === "resourceTimeGridWeek";

    setWeekDoctorMode(isWeekView);

    if (!isWeekView) {
      setCurrentDoctorIndex(0);
    }
    const viewType = info.view.type;
    let startDate = "";
    let endDate = "";
    if (viewType === "resourceTimeGridDay") {
      startDate = moment(info.start).format("DD-MM-YYYY");
      endDate = startDate;
    } else if (viewType === "resourceTimeGridWeek") {
      startDate = moment(info.start).format("DD-MM-YYYY");
      endDate = moment(info.end).subtract(1, "day").format("DD-MM-YYYY");
    } else if (viewType === "resourceTimelineMonth") {
      startDate = moment(info.start).startOf("month").format("DD-MM-YYYY");
      endDate = moment(info.start).endOf("month").format("DD-MM-YYYY");
    } else if (viewType === "multiMonthYear") {
      startDate = moment(info.start).startOf("year").format("DD-MM-YYYY");
      endDate = moment(info.start).endOf("year").format("DD-MM-YYYY");
    }
    setBookingSearchParams((prev) => ({
      ...prev,
      startTime: startDate,
      endTime: endDate,
    }));
  };

  const handleEncounter = () => {
    navigate(
      `${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${patientCareRouteList.patientEnounter}/${editDetails?.patientId}?bookingId=${editDetails?.id}`,
    );
  };
  const handleRegister = () => {
    navigate(
      `${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${patientCareRouteList.patientRegistration}/0?bookingId=${editDetails?.id}`,
    );
  };

  const showAge = (
    dob?: string | null,
    details?: Pick<
      BookingFormType,
      "age" | "ageYears" | "ageMonths" | "ageDays"
    > | null,
  ) => {
    const ageTypes = {
      D: "days",
      D1: "day",
      M: "months",
      M1: "month",
      Y: "years",
      Y1: "year",
    };

    if (dob && String(dob).trim()) {
      const calculated = calculateAge(dob);
      if (Number.isFinite(calculated.age)) {
        const ageType =
          calculated.age == 1
            ? ageTypes[
                `${calculated.ageType}${calculated.age}` as keyof typeof ageTypes
              ]
            : ageTypes[calculated.ageType];
        return `${calculated.age} ${ageType}`;
      }
    }

    if (details?.age && String(details.age).trim()) {
      return String(details.age);
    }

    const years = details?.ageYears ?? 0;
    const months = details?.ageMonths ?? 0;
    const days = details?.ageDays ?? 0;

    if (years > 0) {
      return `${years} ${years === 1 ? "year" : "years"}`;
    }
    if (months > 0) {
      return `${months} ${months === 1 ? "month" : "months"}`;
    }
    if (days > 0) {
      return `${days} ${days === 1 ? "day" : "days"}`;
    }

    return "-";
  };

  const [allEvents, setAllEvents] = useState<BookingListType[]>([]);
  const [allResources, setAllResources] = useState<any[]>([]);
  const [bookingDoctors, setBookingDoctors] = useState<BackendDoctor[]>([]);

  const [filteredEvents, setFilteredEvents] = useState<BookingListType[]>([]);

  const handlePatientsearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const search = e.target.value.toLowerCase().trim();
      setSearchText(search);

      if (!search) {
        setFilteredEvents(allEvents);
        return;
      }

      const filtered = allEvents.filter((event: BookingListType) => {
        const d = event.extendedProps?.data;
        if (!d) return false;

        const patientName = `${d.firstName} ${d.lastName}`.toLowerCase();
        const phone = d.mobileNumber?.toString() || "";
        const registerId = d.patientId?.toString().toLowerCase() || "";
        const doctorName = d.doctor?.doctorName?.toLowerCase() || "";
        const department = d.department?.departmentName?.toLowerCase() || "";

        return (
          patientName.includes(search) ||
          phone.includes(search) ||
          registerId.includes(search) ||
          doctorName.includes(search) ||
          department.includes(search)
        );
      });

      setFilteredEvents(filtered);
    },
    [allEvents],
  );

  useEffect(() => {
    if (
      refetch ||
      Boolean(bookingSearchParam.startTime && bookingSearchParam.endTime)
    ) {
      fetchAllDoctors({
        clinicId,
        startDate: bookingSearchParam.startTime,
        endDate: bookingSearchParam.endTime,
        doctorId: null,
      });
    }
  }, [refetch, bookingSearchParam, bookingCancelPermanent]);

  useEffect(() => {
    if (!skipDetailsCloseRef.current) return;
    const frameId = requestAnimationFrame(() => {
      reanchorBookingDetails();
      skipDetailsCloseRef.current = false;
    });
    return () => cancelAnimationFrame(frameId);
  }, [filteredEvents, reanchorBookingDetails]);

  useEffect(() => {
    if (!bookingSearchParam.startTime || !bookingSearchParam.endTime) {
      return;
    }

    const payload = {
      clinicId,
      startDate: bookingSearchParam.startTime,
      endDate: bookingSearchParam.endTime,
      doctorId: null,
    };

    const intervalId = window.setInterval(() => {
      fetchAllDoctors(payload);
    }, 10000);

    return () => window.clearInterval(intervalId);
  }, [
    bookingSearchParam.startTime,
    bookingSearchParam.endTime,
    fetchAllDoctors,
  ]);

  const renderEventContent = (arg: any) => {
    if (!arg.event.start || !arg.event.end) return null;

    const start = moment.utc(arg.event.start);
    const end = moment.utc(arg.event.end);

    const durationMinutes = end.diff(start, "minutes");

    const data = arg.event.extendedProps?.data;
    // const inCareStatus = data?.journeyStatus === "Emr Started";
    const isTinySlot = durationMinutes <= 10;
    const isMediumSlot = durationMinutes > 10 && durationMinutes <= 15;
    const isLargeSlot = durationMinutes > 15;

    const shouldShowHover = durationMinutes <= 50;
    const isDayView = arg.view?.type === "resourceTimeGridDay";

    const timeText = `${formatLocalDateTime(
      data?.startDate ?? arg.event.start,
      "hh:mm A",
      "",
    )} – ${formatLocalDateTime(data?.endDate ?? arg.event.end, "hh:mm A", "")}`;

    const metaText = [
      data?.tokenNo != null && data?.tokenNo !== ""
        ? `Token: ${data.tokenNo}`
        : null,
      data?.roomNo ? `Room: ${data.roomNo}` : null,
    ]
      .filter(Boolean)
      .join(" | ");

    const isTemporary = data?.isCompleted === 0 && data?.temporaryBooking === 1;
    const isBookingConfirmed = Number(data?.bookingConfirmed) === 1;
    const isCancelled = data?.status === 0;
    const isEncountered = data?.journeyStatus === "Encountered";
    const isConfirmed = data?.journeyStatus === "Booking Confirmed";
    const Arrived = data?.journeyStatus === "Arrived";
    const noShow = data?.journeyStatus === "No Show";
    const inCare = data?.journeyStatus === "Emr Started";
    const isBilled = data?.journeyStatus === "Billed";
    const isCashed = data?.journeyStatus === "Cashed";
    const isBooked = data?.journeyStatus === "Booked";
    const isRegistered = data?.journeyStatus === "Registered";

    // Hover text (SAME AS OLD)
    const hoverText = shouldShowHover
      ? `Patient : ${arg.event.title}
Token   : ${data?.tokenNo ?? "-"}
Time    : ${timeText}
Mobile  : ${data?.mobileNumber ?? "-"}`
      : undefined;

    // Padding control
    const paddingClass = isTinySlot
      ? isTemporary
        ? "pt-3 p-[2px]"
        : "p-[2px]"
      : isMediumSlot
        ? isTemporary
          ? "pt-3 px-1 py-[2px]"
          : "px-1 py-[2px]"
        : isTemporary
          ? "pt-4 px-2 py-1"
          : "px-2 py-1";

    const statusColorByLabel: Record<string, string> = {
      Booked: "#03fcba",
      Registered: "#8b5cf6",
      Confirmed: "#22c55e",
      Arrived: "#ec4899",
      "In Care": "#c2fc03",
      Encountered: "#3b82f6",
      Billed: "#f97316",
      Cashed: "#0891b2",
      "No Show": "#000000",
      Cancelled: "#ef4444",
    };

    const legendLabel = isCancelled
      ? "Cancelled"
      : noShow
        ? "No Show"
        : inCare
          ? "In Care"
          : isEncountered
            ? "Encountered"
            : isCashed
              ? "Cashed"
              : isBilled
                ? "Billed"
                : Arrived
                  ? "Arrived"
                  : isConfirmed
                    ? "Confirmed"
                    : isRegistered
                      ? "Registered"
                      : isBooked
                        ? "Booked"
                        : "Booked";

    const eventColor = statusColorByLabel[legendLabel] || "#03fcba";
    const useDarkText = legendLabel === "Booked" || legendLabel === "In Care";
    const textColor = useDarkText ? "text-gray-900" : "text-white";
    const subTextColor = useDarkText ? "text-gray-700" : "text-white/90";
    const strikeClass = isCancelled ? "line-through opacity-90" : "";
    const bgStyle = {
      backgroundColor: eventColor,
      border: `1px solid ${eventColor}`,
    };

    return (
      <div
        title={hoverText}
        className={`
    relative w-full h-full min-h-0 overflow-hidden
    rounded-md shadow-sm
    ${paddingClass}
    ${isTinySlot
            ? "flex items-center justify-center"
            : "flex flex-col justify-start"
          }
  `}
        style={bgStyle}
      >
        {/* TEMP indicator */}
        {isTemporary && !isBookingConfirmed && (
          <>
            {/* ≤10 min → pill */}
            {isTinySlot && (
              <span className="absolute top-[2px] right-[2px] bg-pink-500 text-white text-[9px] px-[4px] py-[1px] rounded font-semibold leading-none">
                TEMP
              </span>
            )}

            {/* >10 min → ribbon */}
            {!isTinySlot && (
              <span className="absolute top-0 right-0 w-[44px] h-[44px] overflow-hidden pointer-events-none">
                <span
                  className={`absolute top-[2px] right-[2px] bg-pink-500 text-white rounded font-semibold leading-none ${
                    isMediumSlot && isDayView
                      ? "text-[8px] px-[3px] py-[1px]"
                      : "text-[9px] px-[4px] py-[1px]"
                  }`}
                >
                  TEMP 
                </span>
              </span>
            )}
          </>
        )}

        {/* ≤10 minutes → Name only */}
        {isTinySlot && (
          <div
            className={`text-[11px] font-bold text-center truncate leading-tight
          ${textColor} ${strikeClass}`}
          >
            {arg.event.title}
            {metaText ? ` [${metaText}]` : ""}
          </div>
        )}

        {/* 11–15 minutes */}
        {isMediumSlot && (
          isDayView ? (
            <div className="flex flex-col gap-[1px] min-w-0">
              <div
                className={`text-[9px] font-semibold leading-[1.2] whitespace-normal break-words
            ${subTextColor} ${strikeClass}`}
              >
                {timeText}
                {metaText ? ` [${metaText}]` : ""}
              </div>

              <div className="flex items-start justify-between gap-1 min-w-0">
                <div
                  className={`text-[11px] font-bold whitespace-normal break-words leading-[1.2] min-w-0 flex-1
            ${textColor} ${strikeClass}`}
                >
                  {arg.event.title}
                </div>

                <div
                  className={`text-[9px] whitespace-nowrap text-right leading-[1.2] shrink-0
            ${subTextColor}`}
                >
                  {data?.mobileNumber}
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-col gap-[1px] min-w-0">
              <div
                className={`text-[9px] font-semibold leading-[1.15] whitespace-normal break-words
            ${subTextColor} ${strikeClass}`}
              >
                {timeText}
                {metaText ? ` [${metaText}]` : ""}
              </div>

              <div
                className={`text-[10px] font-bold whitespace-normal break-words leading-[1.15]
            ${textColor} ${strikeClass}`}
              >
                {arg.event.title}
              </div>

              <div
                className={`text-[8px] whitespace-normal break-all leading-[1.15]
            ${subTextColor}`}
              >
                {data?.mobileNumber}
              </div>
            </div>
          )
        )}

        {/* 15+ minutes */}
        {isLargeSlot && (
          <>
            <div
              className={`text-[9px] font-semibold  leading-tight
            ${subTextColor} ${strikeClass}`}
            >
              {timeText}
              {metaText ? ` [${metaText}]` : ""}
            </div>

            <div
              className={`text-[12px] font-bold truncate leading-tight
            ${textColor} ${strikeClass}`}
            >
              {arg.event.title}
            </div>

            <div
              className={`text-[11px] truncate leading-tight
            ${subTextColor}`}
            >
              {data?.mobileNumber}
            </div>
          </>
        )}
      </div>
    );
  };

  const handlePrevDoctor = (e: MouseEvent) => {
    e.stopPropagation();
    setCurrentDoctorIndex((prev) =>
      prev > 0 ? prev - 1 : allResources.length - 1,
    );
  };

  const handleNextDoctor = (e: MouseEvent) => {
    e.stopPropagation();
    setCurrentDoctorIndex((prev) =>
      prev < allResources.length - 1 ? prev + 1 : 0,
    );
  };

  const renderResourceLabel = (arg: any) => {
    if (!arg.resource) {
      return null;
    }

    const color = arg.resource.extendedProps?.color;

    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "24px 1fr 24px",
          alignItems: "center",
          width: "100%",
          fontWeight: 600,
          color: color || "#000",
        }}
      >
        {/* LEFT ARROW */}
        {weekDoctorMode ? (
          <span
            onClick={handlePrevDoctor}
            style={{
              cursor: "pointer",
              userSelect: "none",
              textAlign: "left",
            }}
          >
            ◀
          </span>
        ) : (
          <span />
        )}

        {/* CENTER TITLE */}
        <span>{arg.resource.title}</span>

        {/* RIGHT ARROW */}
        {weekDoctorMode ? (
          <span
            onClick={handleNextDoctor}
            style={{
              cursor: "pointer",
              userSelect: "none",
              textAlign: "right",
            }}
          >
            ▶
          </span>
        ) : (
          <span />
        )}
      </div>
    );
  };

  const SLOT_LEGEND = [
    { label: "Booked", color: "#03fcba" },
    { label: "Registered", color: "#8b5cf6" }, // violet-500 ✅ UPDATED
    { label: "Confirmed", color: "#22c55e" }, // green
    { label: "Arrived", color: "#ec4899" }, // pink
    { label: "In Care", color: "#c2fc03" }, // pink
    { label: "Encountered", color: "#3b82f6" }, // blue
    { label: "Billed", color: "#f97316" }, // orange
    { label: "Cashed", color: "#0891b2" }, // cyan-600
    { label: "No Show", color: "#000000" }, // black
    { label: "Cancelled", color: "#ef4444" }, // red-500
  ];
  const SlotLegend = () => {
    return (
      <div className="flex flex-wrap items-center gap-4 px-4 py-2  bg-white">
        {SLOT_LEGEND.map((item) => (
          <div key={item.label} className="flex items-center gap-2">
            <span
              style={{
                width: 13,
                height: 13,
                borderRadius: "90%",
                backgroundColor: item.color,
                display: "inline-block",
              }}
            />
            <span className="text-sm text-gray-700">{item.label}</span>
          </div>
        ))}
      </div>
    );
  };

  const [cancelModalOpen, setCancelModalOpen] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const handleConfirmCancel = () => {
    if (!cancelReason.trim()) {
      showSnackbar({
        message: "Please enter a cancellation reason",
        variant: "warning",
        open: true,
        duration: 2000,
      });
      return;
    }

    bookingCancelPermanent({
      bookingId: Number(editDetails?.id),
      permanentDelete: 0,
      clinicId: clinicId,
      reason: cancelReason,
    });

    setCancelModalOpen(false);
  };

  const [searchText, setSearchText] = useState("");

  const [currentDoctorIndex, setCurrentDoctorIndex] = useState(0);
  const [weekDoctorMode, setWeekDoctorMode] = useState(false);
  const filteredResources = useMemo(() => {
    if (!searchText) return allResources;

    const doctorIds = new Set(filteredEvents.map((e) => e.resourceId));

    return allResources.filter((r) => doctorIds.has(r.id));
  }, [searchText, filteredEvents, allResources]);
  const activeResources = searchText ? filteredResources : allResources;

  const visibleDoctor = activeResources[currentDoctorIndex];

  const visibleResources = useMemo(() => {
    // WEEK VIEW → always single doctor
    if (weekDoctorMode) {
      return visibleDoctor ? [visibleDoctor] : [];
    }

    // OTHER VIEWS
    if (searchText) {
      return filteredResources;
    }

    return allResources;
  }, [
    weekDoctorMode,
    visibleDoctor,
    searchText,
    filteredResources,
    allResources,
  ]);

  const handleDateClick = (info: DateClickArg) => {
    setEditDetails(null);
    // ✅ ALWAYS available
    const clickedDate = info.dateStr;

    // YEAR VIEW
    if (info.view.type === "multiMonthYear") {
      setTimeSlot({
        slotType: info.view.type,
        startTime: clickedDate, // ✅ THIS is what you want
        endTime: null,
        timeSlotNo: 0,
        times: "",
        visitType: null,
        notes: "",
        email: "",
      });

      setOpen(true);
      return;
    }
  };
  const isYearView = currentView === "multiMonthYear";

  const BASE_OPTIONS = [
    "Booked",
    "Booking Confirmed",
    "Registered",
    "Arrived",
    "Encountered",
    "No Show",
    "Booking Cancelled",
    "In Care",
    "Billed",
    "Cashed",
    "Cashier Cancelled"
  ];

  const STATUS_OPTIONS: Record<string, string[]> = {
    Booked: [
      "Booking Confirmed",
      "Arrived",
      "No Show",
      "Booking Cancelled",
    ],
    "Booking Confirmed": [
      "Arrived",
      "No Show",
      "Booking Cancelled",
    ],
    Registered: [
      "Arrived",
      "No Show",
      "Booking Cancelled",
    ],
    Arrived: [
      "No Show",
      "Booking Cancelled",
    ],
    Encountered: [
      "In Care",
      "Billed",
      "Cashed",
    ],
    "No Show": [
      "Booked",
      "Booking Confirmed",
      "Booking Cancelled",
    ],
    "Booking Cancelled": [],
    "In Care": [
      "Billed",
      "Cashed",
    ],
    Billed: [
      "Cashed",
    ],
    Cashed: ["Cashier Cancelled"],
    "Cashier Cancelled": [],
  };
const currentStatus = getDisplayStatus(editDetails?.journeyStatus || "");


 useEffect(() => {
  if (editDetails?.journeyStatus) {
    const displayStatus = getDisplayStatus(editDetails.journeyStatus);

    const currentItem =
      STATUS_OPTIONS[
        displayStatus as keyof typeof STATUS_OPTIONS
      ];

    if (currentItem) {
      setValue("statusDropdown", displayStatus);
    }
  }
}, [editDetails, setValue]);
  return (
    <div className="px-2 py-3">
      <Snackbar
        message="Do you want to stop copying ?"
        action={
          <Button
            onClick={() => {
              setCopy(null);
              setCopyId({ departmentId: null, doctorId: null });
            }}
          >
            stop
          </Button>
        }
        open={copy == "multi"}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      />
      <Snackbar
        open={confirm}
        message="Do you want to change the appointment ?"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        action={
          <div className="flex gap-2">
            <Button
              color={"error"}
              onClick={() => {
                setConfirm(false);
                setRefetch(true);
              }}
            >
              no
            </Button>
            <Button color={"success"} onClick={updateFn}>
              yes
            </Button>
          </div>
        }
      />
      <Paper>
        {doctorsLoading ? (
          <LinearProgress color="primary" />
        ) : (
          <Box
            sx={{
              width: "100%",
              height: 4,
              backgroundColor: theme.palette.primary.main,
            }}
          />
        )}
        <div className="p-2" ref={wrapperRef}>
          <div className="pb-2 grid grid-cols-12 gap-2 items-center">
            {/* Title */}
            <div className="col-span-2 flex items-center">
              <Typography color="primary" fontSize="1rem" fontWeight={600}>
                Patient Booking
              </Typography>
            </div>

            {/* Search */}
            <div className="col-span-2">
              <TextField
                size="small"
                label="Search"
                fullWidth
                onChange={handlePatientsearch}
              />
            </div>

            {/* Doctor filter dropdown */}
            <div className="col-span-3">
              <DoctorSelectDropdown
                doctors={bookingDoctors}
                loading={doctorsLoading}
              />
            </div>

            {/* Slot legend */}
            <div className="col-span-5 flex justify-end">
              <SlotLegend />
            </div>
          </div>

          <FullCalendar
            ref={calendarRef}
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin,
              listPlugin,
              momentPlugin,
              multiMonthPlugin,
              resourceTimeGridPlugin,
              resourceTimelinePlugin,
            ]}
            allDaySlot={false}
            resourceLabelContent={renderResourceLabel}
            resources={visibleResources}
            events={filteredEvents}
            views={{
              resourceTimeGridWeek: {
                type: "resourceTimeGrid",
                duration: { weeks: 1 },
                buttonText: "Week",
                dayHeaderContent: (arg) => {
                  const date = arg.date;

                  const dayNumber = date.getDate();
                  const weekday = date.toLocaleDateString("en-US", {
                    weekday: "long",
                  });

                  return `${dayNumber} - ${weekday}`;
                },
              },
              resourceTimelineMonth: {
                resourceAreaHeaderContent: "DOCTORS",
                type: "resourceTimeline",
                duration: { months: 1 },
                buttonText: "Month",

                slotLabelContent: (arg: any) => {
                  const date = arg.date;

                  return `${date.getDate()} - ${date.toLocaleDateString(
                    "en-US",
                    {
                      weekday: "long",
                    },
                  )}`;
                },
              },
            }}
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right:
                "upcomingAppointments appointmentList resourceTimeGridDay,resourceTimeGridWeek,resourceTimelineMonth,multiMonthYear",
            }}
            timeZone="UTC"
            slotDuration={
              durations[
              `${bookingSearchParam?.doctor?.duration || 12}` as keyof typeof durations
              ] || "00:10"
            }
            slotMinWidth={120}
            slotEventOverlap={false}
            initialView="resourceTimeGridDay"
            eventContent={renderEventContent}
            slotMinTime={"07:00:00"}
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={2}
            droppable={true}
            eventDurationEditable={true}
            select={handleDateSelect}
            eventClick={handleEventClick}
            eventDrop={handleEventDrop}
            height="calc(100vh - 138px)"
            eventAllow={handleDrag}
            datesSet={handleDateChange}
            eventResize={handleEventResize}
            themeSystem="standard"
            dayCellDidMount={handleDayCellDidMount}
            customButtons={{
              upcomingAppointments: {
                text: "Upcoming appointments",
                click: handleOpenUpcomingModal,
              },
              appointmentList: {
                text: "Appointment List Report",
                click: () => {
                  navigate(
                    `${base}${moduleRoutes.mainRoute}/${moduleRoutes.reports}/${reportsRoutesList.appointmentReport}`,
                    { state: { fromCalendar: true } },
                  );
                },
              },
            }}
            dateClick={handleDateClick}
          />
        </div>
      </Paper>
      <div className="cursor-pointer"></div>
      {editDetails && (
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={Boolean(anchorEl)}
          onClose={handleDetailsMenuClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflowY: "auto",
              zIndex: 99999,
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <div className="w-[22vw] h-fit flex flex-col">
            <div className="py-1 px-2 border-b flex justify-between items-center">
              <div className="flex items-center gap-2 ps-2">
                {/* <PersonIcon /> */}
                <ListItemText
                  primary={
                    <div className="px-2">{`${editDetails?.firstName} ${editDetails?.middleName ||""} ${editDetails?.lastName}`}</div>
                  }
                  secondary={
                    <div>
                      <PhoneIphoneIcon /> {`${editDetails?.mobileNumber}`}
                    </div>
                  }
                  sx={{ fontSize: "1rem", fontWeight: 600 }}
                />
                {editDetails?.patientId && (
                  <span>({editDetails?.patientId})</span>
                )}
              </div>
              <IconButton
                size="small"
                color="error"
                onClick={handleCloseDetails}
              >
                <CancelIcon />
              </IconButton>
            </div>
            <div className="p-2">
              <Table aria-label="simple table">
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ border: 0 }}>
                      <strong>Token</strong>
                    </TableCell>
                    <TableCell sx={{ border: 0 }}>
                      : {editDetails?.tokenNo ?? "-"}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ border: 0 }}>
                      <strong>Start time</strong>
                    </TableCell>
                    <TableCell sx={{ border: 0 }}>
                      :{" "}
                      {moment(
                        editDetails?.startDate,
                        "YYYY-MM-DDTHH:mm:ss",
                      ).format("DD-MM-YYYY hh:mm A")}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ border: 0 }}>
                      <strong>End time</strong>
                    </TableCell>
                    <TableCell sx={{ border: 0 }}>
                      :{" "}
                      {moment(
                        editDetails?.endDate,
                        "YYYY-MM-DDTHH:mm:ss",
                      ).format("DD-MM-YYYY hh:mm A")}
                    </TableCell>
                  </TableRow>
                  {!countrycodegrants && (
                  <TableRow>
                    <TableCell sx={{ border: 0 }}>
                      <strong>Age</strong>
                    </TableCell>
                    <TableCell sx={{ border: 0 }}>
                      : {showAge(editDetails?.dob, editDetails)}
                    </TableCell>
                  </TableRow>
                  )}
                  <TableRow>
                    <TableCell sx={{ border: 0 }}>
                      <strong>Gender</strong>
                    </TableCell>
                    <TableCell sx={{ border: 0 }}>
                      : {editDetails?.gender}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Doctor</strong>
                    </TableCell>
                    <TableCell>: {editDetails?.doctor?.doctorName}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ border: 0 }}>
                      <strong>Grouping</strong>
                    </TableCell>
                    <TableCell sx={{ border: 0 }}>
                      : {editDetails?.grouping || "-"}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>
            {!isYearView && (
              <div className="flex  items-center gap-2 px-2">
                <div>
                  {editDetails?.isCompleted == 2 ? (
                    <div className="ps-3">
                      <Tooltip title="Encounter completed">
                        <DoneAllIcon
                          sx={{ color: theme.palette.success.main }}
                        />
                      </Tooltip>
                    </div>
                  ) : editDetails?.status === 0 ? (
                    <Tooltip
                      title={editDetails?.reason || ""}
                      placement="top"
                      arrow
                    >
                      <Typography
                        color="error"
                        sx={{
                          maxWidth: "240px",
                          whiteSpace: "pre-line",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          cursor: "pointer",
                        }}
                      >
                        <strong>Reason:</strong> {editDetails?.reason}
                      </Typography>
                    </Tooltip>
                  ) : editDetails?.patientId ? (
                    <Button onClick={handleEncounter}>encounter</Button>
                  ) : (
                    <Button onClick={handleRegister} color="success">
                      register
                    </Button>
                  )}
                </div>

                <div className="col-span-2 w-full">
                  <CustomFormField
                    name="statusDropdown"
                    control={control}
                    element="autocomplete"
                    fieldProps={{ label: "Status" }}
                    rules={{
                      required: "Status required",
                      onChange: handleConfirmBooking,
                    }}
                    options={
  STATUS_OPTIONS[
    currentStatus as keyof typeof STATUS_OPTIONS
  ] || BASE_OPTIONS
}
                    loading={false}
                    autocompleteProps={{
                      isOptionEqualToValue: (option, value) => option == value,
                      getOptionLabel: (option) => option,
                      readOnly:
                        editDetails?.journeyStatus === "Booking Cancelled" ||
                        editDetails?.journeyStatus === "Cashier Cancelled",
                      open:
                        editDetails?.journeyStatus === "Booking Cancelled"
                          ? false
                          : undefined,
                      disableClearable: true,
                    }}
                  />
                </div>

                <div className="flex gap-2">
                  {editDetails?.status === 1 && editDetails?.isCompleted == 2 ? (
                    <></>
                  ) : editDetails?.status === 1 && (
                    <Tooltip title="Edit appointment">
                      <IconButton
                        sx={{ margin: 0 }}
                        color="success"
                        onClick={handleEdit}
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  )}

                  {editDetails?.isCompleted !== 2 && (
                    <Tooltip
                      title={
                        editDetails?.status === 1
                          ? "Cancel appointment"
                          : "Delete slot"
                      }
                    >
                      <IconButton
                        disabled={cancelLoading}
                        onClick={handleDelete}
                        color="error"
                      >
                        {cancelLoading ? (
                          <CircularProgress size={18} color="error" />
                        ) : (
                          <DeleteIcon />
                        )}
                      </IconButton>
                    </Tooltip>
                  )}
                </div>
              </div>
            )}
          </div>
        </Menu>
      )}
      <CustomModal
        title="Upcoming appointments"
        open={upcomingModalOpen}
        setOpen={setUpcomingModalOpen}
        handleClose={handleCloseUpcomingModal}
      >
        <div className="p-4">
          {upcomingLoading ? (
            <div className="flex justify-center py-8">
              <CircularProgress size={32} />
            </div>
          ) : upcomingBookingsData?.responseIndicator !== "success" ? (
            <Typography color="error">
              {upcomingBookingsData?.responseMessage ||
                "Failed to load upcoming appointments."}
            </Typography>
          ) : upcomingBookings.length === 0 ? (
            <Typography>No upcoming appointments found.</Typography>
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Patient</TableCell>
                  <TableCell>Patient ID</TableCell>
                  <TableCell>Department</TableCell>
                  <TableCell>Doctor</TableCell>
                  <TableCell>Review Date</TableCell>
                  <TableCell>Mobile</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {upcomingBookings.map((item, index) => {
                  const isClickable = item.reviewStatus === "NOT_CONFIRMED";

                  return (
                  <TableRow
                    key={`${item.patientDetails.mrn}-${item.reviewDateTime}-${index}`}
                    hover={isClickable}
                    className={isClickable ? "cursor-pointer" : undefined}
                    onClick={
                      isClickable
                        ? () => handleUpcomingItemClick(item)
                        : undefined
                    }
                    sx={
                      isClickable
                        ? undefined
                        : { cursor: "default", opacity: 0.75 }
                    }
                  >
                    <TableCell>{item.patientDetails.patientName}</TableCell>
                    <TableCell>{item.patientDetails.mrn}</TableCell>
                    <TableCell>{item.departmentDetails.departmentName}</TableCell>
                    <TableCell>{item.doctorDetails.doctorName}</TableCell>
                    <TableCell>
                      {formatLocalDateTime(item.reviewDateTime)}
                    </TableCell>
                    <TableCell>{item.patientDetails.mobileNo || "-"}</TableCell>
                  </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          )}
        </div>
      </CustomModal>

      <CustomModal
        title="Confirm next appointment"
        open={upcomingConfirmOpen}
        setOpen={setUpcomingConfirmOpen}
        handleClose={handleCloseUpcomingConfirm}
      >
        <div className="p-4 flex flex-col gap-4">
          <Typography fontWeight={600}>
            Do you want to confirm the next appointment for{" "}
            <strong>{selectedUpcoming?.patientDetails.patientName || "-"}</strong> on{" "}
            <strong>
              {selectedUpcoming?.reviewDateTime
                ? formatLocalDateTime(selectedUpcoming.reviewDateTime)
                : "-"}
            </strong>
            ?
          </Typography>
          {selectedUpcoming?.reviewRemarks && (
            <Typography variant="body2" color="text.secondary">
              Remarks: {selectedUpcoming.reviewRemarks}
            </Typography>
          )}
          <div className="flex justify-end gap-2">
            <Button
              color="error"
              variant="contained"
              onClick={handleCloseUpcomingConfirm}
              disabled={saveBookingLoading}
            >
              No
            </Button>
            <Button
              color="success"
              variant="contained"
              onClick={handleConfirmUpcomingBooking}
              disabled={saveBookingLoading}
              endIcon={
                saveBookingLoading && (
                  <CircularProgress size={18} color="inherit" />
                )
              }
            >
              Yes
            </Button>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        title="Patient booking"
        open={open}
        setOpen={setOpen}
        handleClose={handleClose}
      >
        <div className="p-3">
          <BookingForm />
        </div>
      </CustomModal>

      <CustomModal
        title="Copy appointment"
        open={copyOpen}
        setOpen={setCopyOpen}
        handleClose={handleCloseCopy}
      >
        <div className="p-4 flex gap-3">
          Copy this appointment as
          <Button data-operation={"single"} onClick={handleStartCopy}>
            Single
          </Button>
          or
          <Button data-operation={"multi"} onClick={handleStartCopy}>
            Multiple
          </Button>
        </div>
      </CustomModal>
      <CustomModal
        title="Confirm Status Change"
        open={statusConfirmOpen}
        setOpen={setStatusConfirmOpen}
        handleClose={handleCloseStatusConfirm}
      >
        <div className="p-4 flex flex-col gap-4">
          <Typography fontWeight={600}>
            Do you want to change this patient status to{" "}
            <strong>{pendingStatus || "-"}</strong>?
          </Typography>
          <div className="flex justify-end gap-2">
            <Button
              color="error"
              variant="contained"
              onClick={handleCloseStatusConfirm}
            >
              No
            </Button>
            <Button
              color="success"
              variant="contained"
              onClick={handleConfirmStatusUpdate}
            >
              Yes
            </Button>
          </div>
        </div>
      </CustomModal>
      <CustomModal
        title="Cancel Appointment"
        open={cancelModalOpen}
        setOpen={setCancelModalOpen}
        handleClose={() => setCancelModalOpen(false)}
      >
        <div className="p-4 flex flex-col gap-4">
          <Typography fontWeight={600}>
            Please provide a reason for cancellation
          </Typography>
          <TextField
            label="Cancellation Reason"
            multiline
            minRows={3}
            value={cancelReason}
            onChange={(e) => setCancelReason(e.target.value)}
            fullWidth
            required
          />
          <div className="flex justify-end gap-2">
            <Button
              color="error"
              variant="contained"
              onClick={() => setCancelModalOpen(false)}
            >
              Close
            </Button>

            <Button
              color="success"
              variant="contained"
              onClick={handleConfirmCancel}
              disabled={cancelLoading}
              endIcon={
                cancelLoading && <CircularProgress size={18} color="inherit" />
              }
            >
              Confirm Cancel
            </Button>
          </div>
        </div>
      </CustomModal>
    </div>
  );
}

export default CalenderComponent;
const durations = {
  "60": "00:01",
  "30": "00:02",
  "20": "00:03",
  "15": "00:04",
  "12": "00:05",
  "10": "00:06",
  "6": "00:10",
  "5": "00:12",
  "4": "00:15",
  "3": "00:20",
  "2": "00:30",
  "1": "00:60",
};
